import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort-descending",
  "use": "sort-descending-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sort-descending\"><path fill-rule=\"evenodd\" d=\"M9 18v-2H3v2h6ZM3 8h18V6H3v2Zm12 5v-2H3v2h12Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol